module.exports = __webpack_public_path__ + "img/events.01857ff8.svg";